// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import SortPopoverMenu from './SortPopoverMenu';

export default SortPopoverMenu;
